import React from 'react';
import { Box, Container, Typography, Button, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import TelegramIcon from '@mui/icons-material/Telegram';
import logo from '../assets/escobar_logo.jpg';

const Footer = () => {
    const theme = useTheme();

    return (
        <Box sx={{
            background: '#000',
            borderTop: `1px solid transparent`,
            borderImage: `linear-gradient(to right, #000, ${theme.palette.secondary.main}, #000) 1`,
            pt: 8,
            pb: 4
        }}>
            <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
                <Box
                    component="img"
                    src={logo}
                    alt="Escobar Online Book"
                    sx={{ width: '150px', mb: 4, borderRadius: '15px' }}
                />

                <Typography variant="h4" gutterBottom sx={{ color: '#fff', fontWeight: 600 }}>
                    ESCOBAR ONLINE BOOK
                </Typography>
                <Typography variant="subtitle1" gutterBottom sx={{ color: theme.palette.secondary.main }}>
                    Official Handle 🔄
                </Typography>

                <Button
                    variant="contained"
                    startIcon={<WhatsAppIcon />}
                    onClick={() => window.open("https://wa.me/+918169699090")}
                    sx={{
                        mt: 2,
                        mb: 4,
                        px: 6,
                        py: 2,
                        fontSize: '1.2rem',
                        borderRadius: '50px',
                        background: '#25D366',
                        color: '#fff',
                        '&:hover': {
                            background: '#128C7E'
                        }
                    }}
                >
                    Chat on WhatsApp
                </Button>

                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 6 }}>
                    {[
                        { icon: <WhatsAppIcon />, url: 'https://wa.me/+918169699090' },
                        // { icon: <InstagramIcon />, url: 'https://www.instagram.com/rr.onlinegroup/' }, // Removing old insta unless provided
                        { icon: <TelegramIcon />, url: 'https://t.me/escobaronlinebook' }
                    ].map((item, index) => (
                        <IconButton
                            key={index}
                            onClick={() => window.open(item.url)}
                            sx={{
                                color: 'rgba(255,255,255,0.6)',
                                border: '1px solid rgba(255,255,255,0.1)',
                                '&:hover': {
                                    color: theme.palette.secondary.main,
                                    borderColor: theme.palette.secondary.main
                                }
                            }}
                        >
                            {item.icon}
                        </IconButton>
                    ))}
                </Box>

                <Typography variant="body1" sx={{ color: '#fff', mb: 2 }}>
                    WEB LINK 👇 <br />
                    <a href="http://www.escobaronlinebook.com" style={{ color: theme.palette.secondary.main, textDecoration: 'none' }}>www.escobaronlinebook.com</a>
                </Typography>

                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.4)' }}>
                    © {new Date().getFullYear()} ESCOBAR ONLINE BOOK. All rights reserved.
                </Typography>
                <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.2)', display: 'block', mt: 1 }}>
                    Play Responsibly. No Limits in Casino. Superfast Refill.
                </Typography>
            </Container>
        </Box>
    );
};

export default Footer;
